import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'
//分页查询黑名单
export function getBlackList(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationBlacklistAndWhitelist/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}
//添加黑名单
export function addBlackList(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationBlacklistAndWhitelist/gl/v1.0.0/add`,
        method: 'post',
        data
    })
}
// 删除黑名单
export function deleteBlackList(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationBlacklistAndWhitelist/gl/v1.0.0/delete`,
        method: 'post',
        data
    })
}
//黑名单详情
export function getBlackListDetail(data) {
    return request({
        url: `/${systemConfig.businessPrefix}/identificationBlacklistAndWhitelist/gl/v1.0.0/detail`,
        method: 'post',
        data
     })
}
//黑名单修改
export function updateBlackList(data) {
   return request({
        url: `/${systemConfig.businessPrefix}/identificationBlacklistAndWhitelist/gl/v1.0.0/update`,
        method: 'post',
        data
     })
}
